module.exports = __webpack_public_path__ + "media/images/kz_logo-c797c8c0.png";